import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../shared/makeApiCall";
import SunProductsForm from "../../components/forms/sunProducts/SunProductsForm";
import { BannerNotificationType } from "../../components/SimpleBanner";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";

const PAGE_SIZE = 10;

export function SunProductsViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [sunProducts, setSunProducts] = useState({ data: [], total: 0 });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getSunProducts = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page || 1,
      search: search || "",
    };
    let callResult = await makePostApiCall(`getSunProducts`, payload);
    setLoading(false);
    if (callResult.success) {
      const rows = Array.isArray(callResult.data) ? callResult.data : [];
      const currentPage = page || 1;
      setSunProducts({
        data: rows,
        total:
          (currentPage - 1) * PAGE_SIZE +
          rows.length +
          (rows.length === PAGE_SIZE ? 1 : 0),
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createSunProduct = async function (values) {
    let callResult = await makePostApiCall("createSunProducts", values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "SUN product added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunProducts("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateSunProduct = async function (sunProduct, values, index) {
    let callResult = await makePutApiCall(
      `updateSunProducts/${sunProduct.id}`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "SUN product updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunProducts("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddSunProductSlideOver = () => {
    setSlideOver({
      childComponent: (
        <SunProductsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createSunProduct}
        />
      ),
      open: true,
    });
  };

  const viewSunProductDetails = async function (sunProduct, index) {
    setSlideOver({
      childComponent: (
        <SunProductsForm
          sunProduct={sunProduct}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateSunProduct}
        />
      ),
      open: true,
    });
  };

  const deleteSunProduct = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSunProducts/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSunProducts("", 1);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message || "SUN Product deleted",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteSunProduct = function (sunProduct, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteSunProduct(sunProduct.id, index)}
          message={`Are you sure you want to delete ${sunProduct.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const syncSunProductsFromQb = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall(`syncProductsFromQbToSun`);
    setLoading(false);
    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Products synced from QuickBooks",
        type: BannerNotificationType.Success,
      });
      getSunProducts("", 1);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        setShowSimpleNotification({
          show: true,
          title: callResult.data?.error || "Failed to sync from QuickBooks",
          type: BannerNotificationType.Error,
        });
      }
    }
  };

  return {
    askDeleteSunProduct,
    emptyModal,
    setEmptyModelOpen,
    getSunProducts,
    loading,
    openAddSunProductSlideOver,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    sunProducts,
    syncSunProductsFromQb,
    viewSunProductDetails,
  };
}
